import { match } from 'ts-pattern';

import { PublicPlansConfiguration } from '@telialt/core-plans/src/model';
import { TeliaSegment } from '@telialt/utils/src/segment';

import { BlockWidgetType } from '../../models/Content';
import { BlockWidgetData, OfferGroup, WidgetType } from './model';

const transformWidgetConfiguration = (type: WidgetType, configuration: any) => {
    if (type === 'PlansList') {
        if (!configuration) {
            throw new Error('Invalid Block - Widget configuration - Missing configuration');
        }

        const transformedConfiguration: PublicPlansConfiguration = {
            offerGroup: match<OfferGroup, OfferGroup>(configuration.offerGroup)
                .with('MHS', () => 'MHS')
                .with('MBB', () => 'MBB')
                .otherwise(() => {
                    throw new Error(
                        `Invalid Block - Widget configuration - Unsupported offer group: ${configuration?.offerGroup}`,
                    );
                }),
            segment: match(configuration.segment)
                .with('B2C', () => TeliaSegment.B2c)
                .otherwise(() => {
                    throw new Error(
                        `Invalid Block - Widget configuration - Unsupported segment: ${configuration?.segment}`,
                    );
                }),
            filters: match(configuration.filters)
                .with(true, () => true)
                .with(false, () => false)
                .otherwise(() => {
                    throw new Error(
                        `Invalid Block - Widget configuration - Unsupported filters: ${configuration?.filters}`,
                    );
                }),
            sorting: match(configuration.sorting)
                .with(true, () => true)
                .with(false, () => false)
                .otherwise(() => {
                    throw new Error(
                        `Invalid Block - Widget configuration - Unsupported sorting: ${configuration?.sorting}`,
                    );
                }),
        };

        return transformedConfiguration;
    }

    return configuration;
};

export const transformBlockWidget = (content: BlockWidgetType): BlockWidgetData => {
    return {
        type: content.fields.type,
        configuration: transformWidgetConfiguration(content.fields.type, content.fields.configuration),
        relatedContent: content.fields.relatedContent,
    };
};
